/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".docs-DropdownExample{max-width:300px}.docs-DropdownExample .ms-Dropdown-container{margin-bottom:10px}\n"}]);